/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalTemplate from '../../../../frontend/views/components/modal/ModalTemplate.vue'

const __vue_script__ = ({
  name: 'LoadingModal',
  components: {
    ModalTemplate
  },
  props: {
    type: {
      type: Number,
      default: 500
    }
  }
}        )

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-template",
    {
      ref: "modal",
      staticClass: "has-background",
      attrs: { a11yTitle: _vm.L("Loading") },
    },
    [
      _c(
        "template",
        { slot: "title" },
        [
          _vm.type === 500
            ? _c(
                "i18n",
                { staticClass: "is-title-2 c-title", attrs: { tag: "h2" } },
                [_vm._v("500")]
              )
            : _c(
                "i18n",
                { staticClass: "is-title-2 c-title", attrs: { tag: "h2" } },
                [_vm._v("404")]
              ),
        ],
        1
      ),
      _vm.type === 500
        ? _c(
            "div",
            { staticClass: "c-wrapper" },
            [
              _c(
                "i18n",
                { staticClass: "is-title-3 c-title", attrs: { tag: "h2" } },
                [_vm._v("Server error")]
              ),
              _c("i18n", { staticClass: "c-text", attrs: { tag: "p" } }, [
                _vm._v("We are having some trouble. Please try again later."),
              ]),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "c-wrapper" },
            [
              _c(
                "i18n",
                { staticClass: "is-title-3 c-title", attrs: { tag: "h2" } },
                [_vm._v("Page not found")]
              ),
              _c("i18n", { staticClass: "c-text", attrs: { tag: "p" } }, [
                _vm._v("We couldn’t find what you are looking for."),
              ]),
              _c(
                "router-link",
                { staticClass: "button", attrs: { to: "/" } },
                [_c("i18n", [_vm._v("Take me home")])],
                1
              ),
            ],
            1
          ),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-24e45edb_0", { source: ".c-title[data-v-24e45edb] {\n  padding: 1.5rem 0;\n}\n.c-wrapper[data-v-24e45edb] {\n  text-align: center;\n}\n\n/*# sourceMappingURL=ErrorModal.vue.map */", map: {"version":3,"sources":["frontend/views/containers/loading-error/ErrorModal.vue","ErrorModal.vue"],"names":[],"mappings":"AAmCA;EACA,iBAAA;AClCA;ADqCA;EACA,kBAAA;AClCA;;AAEA,yCAAyC","file":"ErrorModal.vue","sourcesContent":["<template lang='pug'>\n  modal-template(class='has-background' ref='modal' :a11yTitle='L(\"Loading\")')\n    template(slot='title')\n      i18n(tag='h2' class='is-title-2 c-title' v-if='type===500') 500\n      i18n(tag='h2' class='is-title-2 c-title' v-else) 404\n\n    .c-wrapper(v-if='type===500')\n      i18n.is-title-3.c-title(tag='h2') Server error\n      i18n.c-text(tag='p') We are having some trouble. Please try again later.\n\n    .c-wrapper(v-else)\n      i18n.is-title-3.c-title(tag='h2') Page not found\n      i18n.c-text(tag='p') We couldn’t find what you are looking for.\n      router-link.button(to='/')\n        i18n Take me home\n</template>\n\n<script>\nimport ModalTemplate from '../../../../frontend/views/components/modal/ModalTemplate.vue'\n\nexport default ({\n  name: 'LoadingModal',\n  components: {\n    ModalTemplate\n  },\n  props: {\n    type: {\n      type: Number,\n      default: 500\n    }\n  }\n}: Object)\n</script>\n\n<style lang=\"scss\" scoped>\n.c-title {\n  padding: 1.5rem 0;\n}\n\n.c-wrapper {\n  text-align: center;\n}\n</style>\n",".c-title {\n  padding: 1.5rem 0;\n}\n\n.c-wrapper {\n  text-align: center;\n}\n\n/*# sourceMappingURL=ErrorModal.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-24e45edb"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template lang='pug'>\n  modal-template(class='has-background' ref='modal' :a11yTitle='L(\"Loading\")')\n    template(slot='title')\n      i18n(tag='h2' class='is-title-2 c-title' v-if='type===500') 500\n      i18n(tag='h2' class='is-title-2 c-title' v-else) 404\n\n    .c-wrapper(v-if='type===500')\n      i18n.is-title-3.c-title(tag='h2') Server error\n      i18n.c-text(tag='p') We are having some trouble. Please try again later.\n\n    .c-wrapper(v-else)\n      i18n.is-title-3.c-title(tag='h2') Page not found\n      i18n.c-text(tag='p') We couldn’t find what you are looking for.\n      router-link.button(to='/')\n        i18n Take me home\n</template>\n\n<script>\nimport ModalTemplate from '../../../../frontend/views/components/modal/ModalTemplate.vue'\n\nexport default ({\n  name: 'LoadingModal',\n  components: {\n    ModalTemplate\n  },\n  props: {\n    type: {\n      type: Number,\n      default: 500\n    }\n  }\n}: Object)\n</script>\n\n<style lang=\"scss\" scoped>\n.c-title {\n  padding: 1.5rem 0;\n}\n\n.c-wrapper {\n  text-align: center;\n}\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__